// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".5aac444f74e4ea1773aa3e65ff155f4de78c564b.chunk.bundle.js";
};